import UserQRCode from './UserQRCode';
export default UserQRCode;
